var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-wrapper col",class:[_vm.fieldType, { 'error': !!_vm.error }]},[_vm._t("default"),(_vm.error)?_c('div',{staticClass:"input-error error text-sm font-bold uppercase italic"},[_vm._v(_vm._s(_vm.error))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }